const GA_EVENT_CATEGORIES = {
  HEADER: 'Header',
  SEARCH: 'Search',
}

const GA_EVENT_ACTIONS = {
  CLICK: 'Click',
  SORT: 'Sort',
  ADD: 'Add',
}

const GA_EVENT_LABELS = {
  SEARCH_BOX: 'Searchbox',
  SEARCH_FOR: 'Search for',
  CURRENT_PAGE: 'dl',
  TITLE_OF_PAGE: 'dt',
  BREADCRUMB_OF_PAGE: 'dp',
}

export {
  GA_EVENT_CATEGORIES,
  GA_EVENT_ACTIONS,
  GA_EVENT_LABELS,
}
